import { BaseEntity } from "./BaseEntity";

export enum FamilyStatus {
  NEEDS_ATTENTION = "needs_attention",
  OK = "ok",
  NO_MEETING_MONTH = "no_meeting_month",
}

export interface Family extends BaseEntity{
  family: string;
  num_of_children:number;
  name_a: string;
  name_b: string;
  residence_location: string;
  mentor_id: string;
  previous_mentor_ids?: string[];
  initial_debt_amount?: number;
  monthly_debt_repayment?: number;
  phone?: string;
  email: string;
  status: FamilyStatus;
  notes?: string;
  budget_sheet_url?: string;
}

export interface BaseFamily {
  id: string;
  familyName: string;
  status: string;
  lastMeetingDate?: string;
}

